{
  "familyId": "STU-GRAFIEK",
  "questions": [
    {
      "id": "STU-GRAFIEK-001",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Bekijk de staafgrafiek. In welke maand regende het het meest?",
      "context": null,
      "options": ["November", "Juli", "Maart", "September"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Maart", "Juli", "September", "November"],
        "values": [45, 60, 55, 80],
        "title": "Regenval per maand (in mm)",
        "xLabel": "Maand",
        "yLabel": "Regenval (mm)"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Maart", "Juli", "September", "November"],
            "values": [45, 60, 55, 80],
            "title": "Regenval per maand (in mm)",
            "xLabel": "Maand",
            "yLabel": "Regenval (mm)",
            "label": "Staafgrafiek: regenval per maand"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staafgrafiek lezen",
            "content": "Kijk naar de hoogte van elke staaf. De hoogste staaf heeft de grootste waarde. November heeft de hoogste staaf (80 mm).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_reading",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: vergelijk de hoogte van alle staven en zoek de hoogste. Stap 1: Lees alle waarden af: Maart = 45 mm, Juli = 60 mm, September = 55 mm, November = 80 mm. Stap 2: Vergelijk: 45 < 55 < 60 < 80. Stap 3: De hoogste staaf is November (80 mm) → in november regende het het meest.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Maart = 45, Juli = 60, September = 55, November = 80",
          "Vergelijk de waarden en zoek de hoogste: 80 mm (November)"
        ],
        "distractorExplanations": {
          "0": "Correct! In november regende het het meest (80 mm).",
          "1": "Veelgemaakte fout: de op één na hoogste staaf kiezen. Juli had 60 mm regen — veel, maar niet het meest. November had 80 mm, dat is 20 mm meer.",
          "2": "Veelgemaakte fout: de laagste staaf kiezen. Maart had 45 mm regen — dat is juist het minst van alle maanden. November had het meest: 80 mm.",
          "3": "Veelgemaakte fout: niet alle staven vergelijken. September had 55 mm regen, maar November had meer: 80 mm."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-002",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Bekijk de staafgrafiek. Hoeveel boeken las Emma in totaal?",
      "context": null,
      "options": ["18", "6", "5", "7"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Q1", "Q2", "Q3"],
        "values": [6, 5, 7],
        "title": "Aantal gelezen boeken per kwartaal",
        "xLabel": "Kwartaal",
        "yLabel": "Aantal boeken"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Q1", "Q2", "Q3"],
            "values": [6, 5, 7],
            "title": "Aantal gelezen boeken per kwartaal",
            "xLabel": "Kwartaal",
            "yLabel": "Aantal boeken",
            "label": "Staafgrafiek: gelezen boeken per kwartaal"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grafiek berekenen",
            "content": "Om het totaal te vinden, tel je alle waarden bij elkaar op: Q1 (6) + Q2 (5) + Q3 (7) = 18 boeken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_calculation",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: tel alle waarden bij elkaar op om het totaal te vinden. Stap 1: Lees alle staven af: Q1 = 6, Q2 = 5, Q3 = 7. Stap 2: Reken: 6 + 5 = 11. Stap 3: 11 + 7 = 18. Emma las in totaal 18 boeken.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Q1 = 6, Q2 = 5, Q3 = 7",
          "Tel alle waarden bij elkaar op: 6 + 5 + 7 = 18 boeken"
        ],
        "distractorExplanations": {
          "0": "Correct! Emma las in totaal 18 boeken (6 + 5 + 7 = 18).",
          "1": "Veelgemaakte fout: maar één staaf aflezen in plaats van optellen. 6 is het aantal boeken in Q1 alleen. Je moet alle kwartalen optellen: 6 + 5 + 7 = 18.",
          "2": "Veelgemaakte fout: maar één staaf aflezen in plaats van optellen. 5 is het aantal boeken in Q2 alleen. Je moet alle kwartalen optellen: 6 + 5 + 7 = 18.",
          "3": "Veelgemaakte fout: maar één staaf aflezen in plaats van optellen. 7 is het aantal boeken in Q3 alleen. Je moet alle kwartalen optellen: 6 + 5 + 7 = 18."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-003",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Bekijk de staafgrafiek. Hoeveel meer leerlingen kiezen voetbal dan tennis?",
      "context": null,
      "options": ["8", "12", "4", "20"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
        "values": [12, 4, 8, 6],
        "title": "Favoriete sport van groep 7",
        "xLabel": "Sport",
        "yLabel": "Aantal leerlingen"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
            "values": [12, 4, 8, 6],
            "title": "Favoriete sport van groep 7",
            "xLabel": "Sport",
            "yLabel": "Aantal leerlingen",
            "label": "Staafgrafiek: favoriete sport groep 7"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verschil berekenen in grafiek",
            "content": "Om het verschil te vinden: lees eerst beide waarden af (voetbal = 12, tennis = 4). Trek dan af: 12 − 4 = 8 leerlingen meer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_difference",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: lees beide waarden af en bereken het verschil door af te trekken. Stap 1: Voetbal = 12 leerlingen. Stap 2: Tennis = 4 leerlingen. Stap 3: Verschil = 12 − 4 = 8 leerlingen meer.",
        "solutionSteps": [
          "Lees voetbal af: 12 leerlingen",
          "Lees tennis af: 4 leerlingen",
          "Bereken het verschil: 12 − 4 = 8"
        ],
        "distractorExplanations": {
          "0": "Correct! Er kiezen 8 meer leerlingen voetbal dan tennis (12 − 4 = 8).",
          "1": "Veelgemaakte fout: het totaal aflezen in plaats van het verschil berekenen. 12 is het aantal leerlingen dat voetbal kiest, niet het verschil met tennis. Het verschil is 12 − 4 = 8.",
          "2": "Veelgemaakte fout: de verkeerde waarde aflezen. 4 is het aantal leerlingen dat tennis kiest, niet het verschil. Het verschil is 12 − 4 = 8.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. 20 zou het totaal zijn als je twee sporten bij elkaar optelt. Bij 'hoeveel meer' moet je aftrekken: 12 − 4 = 8."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-004",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Bekijk de staafgrafiek. Welke conclusie kun je trekken?",
      "context": null,
      "options": [
        "De temperatuur stijgt van januari tot juli.",
        "Het is in april het warmst.",
        "De temperatuur daalt elke maand.",
        "Januari en juli zijn even warm."
      ],
      "correctAnswer": 0,
      "data": {
        "labels": ["Januari", "April", "Juli", "Oktober"],
        "values": [3, 10, 20, 11],
        "title": "Gemiddelde temperatuur per maand (°C)",
        "xLabel": "Maand",
        "yLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Januari", "April", "Juli", "Oktober"],
            "values": [3, 10, 20, 11],
            "title": "Gemiddelde temperatuur per maand (°C)",
            "xLabel": "Maand",
            "yLabel": "Temperatuur (°C)",
            "label": "Staafgrafiek: gemiddelde temperatuur per maand"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusie trekken uit grafiek",
            "content": "Kijk naar het verloop: januari (3°C) → april (10°C) → juli (20°C). De temperatuur stijgt van januari tot juli. Na juli daalt het weer: oktober (11°C).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_conclusion",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: zoek het patroon in de grafiek — stijgt, daalt of schommelt de waarde? Stap 1: Lees alle waarden af: januari = 3°C, april = 10°C, juli = 20°C, oktober = 11°C. Stap 2: Patroon: 3 → 10 → 20 (stijgend) → 11 (dalend). Stap 3: Conclusie: de temperatuur stijgt van januari tot juli, en daalt daarna weer.",
        "solutionSteps": [
          "Lees alle waarden af: jan=3, apr=10, jul=20, okt=11",
          "Zoek het patroon: 3 → 10 → 20 (stijgend) → 11 (dalend)",
          "Conclusie: de temperatuur stijgt van januari tot juli"
        ],
        "distractorExplanations": {
          "0": "Correct! De temperatuur stijgt van 3°C (januari) naar 20°C (juli).",
          "1": "Veelgemaakte fout: niet de hoogste waarde vinden. April (10°C) is niet het warmst — juli (20°C) is de warmste maand in de grafiek. Vergelijk altijd alle waarden.",
          "2": "Veelgemaakte fout: het patroon verkeerd interpreteren. De temperatuur daalt niet elke maand — van januari tot juli stijgt de temperatuur juist (3 → 10 → 20). Alleen na juli daalt het.",
          "3": "Veelgemaakte fout: waarden niet goed aflezen. Januari (3°C) en juli (20°C) zijn niet even warm — juli is 17°C warmer. Lees de waarden zorgvuldig af."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-005",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Bekijk de staafgrafiek. Welke twee vakken zijn samen even populair als wiskunde?",
      "context": null,
      "options": ["Engels en tekenen", "Nederlands en tekenen", "Engels en Nederlands", "Gym en tekenen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Wiskunde", "Nederlands", "Engels", "Tekenen", "Gym"],
        "values": [10, 3, 6, 4, 8],
        "title": "Favoriete vak van groep 8",
        "xLabel": "Vak",
        "yLabel": "Aantal leerlingen"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Wiskunde", "Nederlands", "Engels", "Tekenen", "Gym"],
            "values": [10, 3, 6, 4, 8],
            "title": "Favoriete vak van groep 8",
            "xLabel": "Vak",
            "yLabel": "Aantal leerlingen",
            "label": "Staafgrafiek: favoriete vak groep 8"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Combinaties vergelijken",
            "content": "Wiskunde = 10 leerlingen. Zoek twee vakken die samen ook 10 zijn: Engels (6) + tekenen (4) = 10. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_combination",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: lees de doelwaarde af en probeer combinaties tot je een match vindt. Stap 1: Wiskunde = 10 leerlingen. Stap 2: Probeer combinaties: Engels (6) + tekenen (4) = 10 ✓. Stap 3: Controleer: 10 = 10 → Engels en tekenen zijn samen even populair als wiskunde.",
        "solutionSteps": [
          "Lees wiskunde af: 10 leerlingen",
          "Probeer combinaties: Engels (6) + tekenen (4) = 10 ✓",
          "Controleer: 10 = 10, dus Engels en tekenen zijn samen even populair als wiskunde"
        ],
        "distractorExplanations": {
          "0": "Correct! Engels (6) + tekenen (4) = 10, even veel als wiskunde (10).",
          "1": "Veelgemaakte fout: niet narekenen. Nederlands (3) + tekenen (4) = 7, dat is niet gelijk aan wiskunde (10). Reken altijd na: 3 + 4 = 7 ≠ 10.",
          "2": "Veelgemaakte fout: niet narekenen. Engels (6) + Nederlands (3) = 9, dat is niet gelijk aan wiskunde (10). Reken altijd na: 6 + 3 = 9 ≠ 10.",
          "3": "Veelgemaakte fout: niet narekenen. Gym (8) + tekenen (4) = 12, dat is meer dan wiskunde (10). Reken altijd na: 8 + 4 = 12 ≠ 10."
        }
      }
    }
  ]
}
